/**
 * Map name for mutations
 * @types {string}
 */

export const SET_USER = "AUTH/SET_USER";
export const SET_TOKEN = "AUTH/SET_TOKEN";
export const SET_SIGN_UP_SKELETON = "AUTH/SET_SIGN_UP_SKELETON";
export const SET_SIGN_UP_FLIP_PARTNER_TYPE = "AUTH/SET_SIGN_UP_FLIP_PARTNER_TYPE";
export const SET_PARTNER_TERMS = "AUTH/SET_PARTNER_TERMS";
export const SET_GENDERS = "AUTH/SET_GENDERS";
